import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Story.js
import { useEffect, useState, useRef } from "react";
import { Box, Image, Flex, Progress } from "@chakra-ui/react";
import { AudioStatusButton } from "./icons/AudioStatusButton";
const Story = ({ story, index, total, onNext, onPrev, onUpdateProgress, }) => {
    const [progressValue, setProgressValue] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const videoRef = useRef(null);
    const [isVideo, setIsVideo] = useState(false);
    const [isMuted, setIsMuted] = useState(true);
    const intervalRef = useRef();
    const handleToggleMute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !videoRef.current.muted;
            setIsMuted(videoRef.current.muted);
            videoRef.current.play().catch(() => { });
        }
    };
    const checkIsVideo = (url) => {
        if (!url)
            return false;
        const videoPattern = /(0?mp4|0?mov|0?webm|0?avi)(\?|$)/i;
        return videoPattern.test(url);
    };
    useEffect(() => {
        const videoIsVideo = checkIsVideo(story);
        setIsVideo(videoIsVideo);
        if (videoIsVideo && videoRef.current) {
            const video = videoRef.current;
            const handleTimeUpdate = () => {
                if (isPaused)
                    return;
                const progress = (video.currentTime / video.duration) * 100;
                setProgressValue(progress);
                onUpdateProgress(progress);
            };
            const handleVideoEnd = () => {
                handleNext();
            };
            video.addEventListener("timeupdate", handleTimeUpdate);
            video.addEventListener("ended", handleVideoEnd);
            // Start playing the video
            if (!isPaused) {
                video.play().catch((error) => {
                    console.error("Error playing video:", error);
                });
            }
            return () => {
                video.removeEventListener("timeupdate", handleTimeUpdate);
                video.removeEventListener("ended", handleVideoEnd);
                video.pause();
            };
        }
        else {
            // Clear any existing interval
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            // Set up new interval for images
            const intervalDuration = 5000 / 100;
            intervalRef.current = setInterval(() => {
                if (isPaused)
                    return;
                setProgressValue((prevValue) => {
                    const newValue = Math.min(prevValue + 1, 100);
                    onUpdateProgress(newValue);
                    // If we reach 100%, move to next story
                    if (newValue >= 100) {
                        handleNext();
                    }
                    return newValue;
                });
            }, intervalDuration);
            return () => {
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                }
            };
        }
    }, [story, index, isPaused]);
    useEffect(() => {
        setProgressValue(0);
    }, [index]);
    const handleNext = () => {
        onUpdateProgress(0);
        setProgressValue(0);
        onNext();
    };
    const handlePrev = () => {
        onUpdateProgress(0);
        setProgressValue(0);
        onPrev();
    };
    const handleMouseDown = () => {
        setIsPaused(true);
        if (videoRef.current) {
            videoRef.current.pause();
        }
    };
    const handleMouseUp = () => {
        setIsPaused(false);
        if (videoRef.current) {
            videoRef.current.play().catch((error) => {
                console.error("Error playing video:", error);
            });
        }
    };
    const handleTouchStart = (e) => {
        // e.preventDefault();
        handleMouseDown();
    };
    const handleTouchEnd = (e) => {
        // e.preventDefault();
        handleMouseUp();
    };
    return (_jsxs(Box, { position: "relative", overflow: "hidden", height: "100vh", bg: "black", onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onMouseLeave: handleMouseUp, onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd, children: [_jsx(Flex, { justify: "center", align: "center", height: "100%", width: "100%", children: isVideo ? (_jsxs(Box, { width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", children: [_jsx("video", { ref: videoRef, src: story, style: {
                                maxWidth: "100%",
                                maxHeight: "100%",
                                width: "auto",
                                height: "auto",
                                objectFit: "contain",
                                pointerEvents: "none",
                            }, autoPlay: true, muted: isMuted, playsInline: true, onEnded: handleNext }), _jsx(AudioStatusButton, { type: isMuted ? "unmute" : "mute", onClick: handleToggleMute })] })) : (_jsx(Image, { src: story, alt: "Story", maxH: "100%", maxW: "100%", objectFit: "contain" })) }), _jsxs(Flex, { position: "absolute", top: "50%", transform: "translateY(-50%)", left: 0, right: 0, children: [_jsx(Flex, { w: "45vw", h: "100vh", onClick: handlePrev, "aria-label": "Previous" }), _jsx(Flex, { w: "45vw", h: "100vh", ml: "55%", onClick: handleNext, "aria-label": "Next" })] }), _jsx(Progress, { value: progressValue, size: "xs", position: "absolute", colorScheme: "purple", top: "4", left: index === 0 ? 2 : `calc(${index * (100 / total)}% + 0.5rem)`, width: `calc(${90 / total}% - 5px)`, h: "2px", borderRadius: 4, zIndex: 2 })] }));
};
export default Story;
